<nz-card nzTitle="Knowledge Base Articles" style="margin-bottom: 16px;">
  <p style="margin-bottom: 8px; font-weight: 500;">
    Total: {{ filteredArticles.length }}
  </p>
  <button nz-button nzType="primary" (click)="showAddModal()">+ New Article</button>
  <button nz-button nzType="default" (click)="downloadMarkdown()" style="margin-left: 8px;">
    📄 Export Markdown
  </button>
</nz-card>
<input
  nz-input
  placeholder="Search by title"
  [(ngModel)]="searchText"
  (ngModelChange)="applySearch()"
  style="width: 240px; margin-bottom: 16px;"
/>

<nz-table
  #table
  [nzData]="filteredArticles"
  [nzBordered]="true"
  [nzLoading]="loading"
  [nzSize]="'middle'"
  [nzScroll]="{ x: '1000px' }"
  [nzShowSizeChanger]="true"
  [nzShowQuickJumper]="true"
>
  <thead>
  <tr>
    <th
      nzShowSort
      [nzSortFn]="true"
      [nzSortOrder]="sortMap['title']"
      (nzSortOrderChange)="changeSort('title', $event)"
    >
      Title
    </th>
    <th
      nzShowSort
      [nzSortFn]="true"
      [nzSortOrder]="sortMap['slug']"
      (nzSortOrderChange)="changeSort('slug', $event)"
    >
      Slug
    </th>
    <th
      nzShowSort
      [nzSortFn]="true"
      [nzSortOrder]="sortMap['section']"
      (nzSortOrderChange)="changeSort('section', $event)"
    >
      Section
    </th>
    <th
      nzShowSort
      [nzSortFn]="true"
      [nzSortOrder]="sortMap['subsection']"
      (nzSortOrderChange)="changeSort('subsection', $event)"
    >
      Subsection
    </th>
    <th
      nzShowSort
      [nzSortFn]="true"
      [nzSortOrder]="sortMap['tags']"
      (nzSortOrderChange)="changeSort('tags', $event)"
    >
      Tags
    </th>
    <th
      nzShowSort
      [nzSortFn]="true"
      [nzSortOrder]="sortMap['updatedAt']"
      (nzSortOrderChange)="changeSort('updatedAt', $event)"
    >
      Updated
    </th>
    <th>Actions</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let article of table.data">
    <td>{{ article.title }}</td>
    <td>{{ article.slug }}</td>
    <td>{{ article.section }}</td>
    <td>{{ article.subsection }}</td>
    <td>{{ article.tags.join(', ') }}</td>
    <td>{{ article.updatedAt | date: 'short' }}</td>
    <td>
      <button nz-button nzType="link" (click)="editArticle(article)">Edit</button>
      <button nz-button nzType="text" nzDanger (click)="deleteArticle(article._id)">Delete</button>
    </td>
  </tr>
  </tbody>
</nz-table>

<nz-modal
  [(nzVisible)]="isModalVisible"
  [nzTitle]="isEditing ? 'Edit Article' : 'New Article'"
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleSubmit()"
  [nzOkLoading]="saving"
  [nzWidth]="1200"
>
  <ng-container *nzModalContent>
    <form nz-form style="max-height: 60vh; overflow-y: auto; padding-right: 8px;">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="title" nzRequired>Title</nz-form-label>
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input [(ngModel)]="form.title" name="title" required />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="slug" nzRequired>Slug</nz-form-label>
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input [(ngModel)]="form.slug" name="slug" required />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="section" nzRequired>Section</nz-form-label>
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input
            nz-input
            [(ngModel)]="form.section"
            name="section"
            required
            [nzAutocomplete]="sectionAuto"
            (ngModelChange)="onSectionChange()"
          />
          <nz-autocomplete #sectionAuto>
            <nz-auto-option
              *ngFor="let section of existingSections"
              [nzValue]="section"
            >
              {{ section }}
            </nz-auto-option>
          </nz-autocomplete>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="subsection">Subsection</nz-form-label>
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input
            nz-input
            [(ngModel)]="form.subsection"
            name="subsection"
            [nzAutocomplete]="subsectionAuto"
          />
          <nz-autocomplete #subsectionAuto>
            <nz-auto-option
              *ngFor="let subsection of filteredSubsections"
              [nzValue]="subsection"
            >
              {{ subsection }}
            </nz-auto-option>
          </nz-autocomplete>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="tags">Tags</nz-form-label>
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <nz-tag *ngFor="let tag of form.tags" nzMode="closeable" (nzOnClose)="removeTag(tag)">
            {{ tag }}
          </nz-tag>
          <input
            nz-input
            [(ngModel)]="tagInput"
            (keydown.enter)="addTag()"
            name="tagInput"
            placeholder="Press Enter to add tag"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="content" nzRequired>Content</nz-form-label>
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <nz-tabset [(nzSelectedIndex)]="contentTabIndex">
            <nz-tab nzTitle="Editor">
        <textarea
          nz-input
          rows="8"
          [(ngModel)]="form.content"
          name="content"
          placeholder="# Heading 1\n## Subheading\n- List item\n[Link](https://)"
          required
        ></textarea>
            </nz-tab>
            <nz-tab nzTitle="Preview">
              <markdown [data]="form.content"></markdown>
            </nz-tab>
          </nz-tabset>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="upload">Bilder</nz-form-label>
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <nz-upload
            [nzBeforeUpload]="handleImageUpload"
            [nzShowUploadList]="false"
            nzAccept="image/*"
          >
            <button nz-button type="button">
              📷 Bild hochladen
            </button>
          </nz-upload>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
